import React, { useState, useEffect } from "react";
import { Container, Button, Offcanvas, Nav } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { Link } from "gatsby";
import { linkResolver } from "../../utilities/linkResolver";
import LanguageSwitcher from "../../components/blocks/LanguageSwitcher";
import Navbar from "react-bootstrap/Navbar";
import translations from "../../utilities/translations";

const NavbarMobile = ({ logo, settings, menu, contactInfo, pageData }) => {
  const { handleLogout, handleLogin, user, currentLanguage } = useAuth();
  const [buttonHref, setButtonHref] = useState("/syndesi-eggrafi/");
  const [buttonText, setButtonText] = useState(
    translations("login-register", currentLanguage)
  );
  const [show, setShow] = useState(false);
  const isLoggedIn = !!user;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (user === null) {
      setButtonHref("/syndesi-eggrafi/");
      setButtonText(translations("login-register", currentLanguage));
    } else {
      setButtonHref("/");
      setButtonText(translations("logout", currentLanguage));
    }
  }, [user, currentLanguage]);

  return (
    <Navbar expand={false} sticky="top" className="mobile-navbar d-lg-none">
      <Container fluid className="navbar-mb d-flex">
        <a onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
          >
            <path
              d="M3.375 6.13635H23.625V8.38635H3.375V6.13635ZM3.375 14.0114H16.875V16.2614H3.375V14.0114ZM3.375 21.8864H23.625V24.1364H3.375V21.8864Z"
              fill="#473D33"
            />
          </svg>
        </a>

        <Navbar.Brand href="/" className="me-0">
          <img src={logo?.localFile?.publicURL} alt="xerolivado logo" />
        </Navbar.Brand>

        <div className={`user-btn ${isLoggedIn ? "logged-in" : "logged-out"}`}>
          <a
            // href={`/syndesi-eggrafi/`}
            href={`${isLoggedIn ? "/file-page/" : "/syndesi-eggrafi/"}`}
          >
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              xmlns="http://www.w3.org/2000/svg"
              style={{ fill: isLoggedIn ? "#70b848" : "#fff" }}
            >
              <g id="Frame 12">
                <path
                  id="Union"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.6241 4.33332C10.6241 6.35837 8.98247 7.99999 6.95742 7.99999C4.93238 7.99999 3.29075 6.35837 3.29075 4.33332C3.29075 2.30828 4.93238 0.666656 6.95742 0.666656C8.98247 0.666656 10.6241 2.30828 10.6241 4.33332ZM6.63016 8.91666C3.99841 8.91666 1.4565 10.3173 0.850579 12.8767C0.733245 13.3726 0.639746 13.8914 0.587496 14.4185C0.537079 14.9217 0.951412 15.3333 1.45741 15.3333H12.4574C12.9634 15.3333 13.3777 14.9227 13.3273 14.4185C13.2751 13.8914 13.1816 13.3726 13.0642 12.8767C12.4583 10.3164 9.91641 8.91666 7.28466 8.91666H6.63016Z"
                />
              </g>
            </svg>
          </a>
        </div>

        <Offcanvas show={show} onHide={handleClose}>
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <ul className="list-unstyled nav-menu mb-3">
              <li className="my-3">
                <Nav.Link href={currentLanguage === "el-GR" ? "/" : "/en"}>
                  {translations("homepage", currentLanguage)}
                </Nav.Link>
              </li>
              {menu.map((item, index) => {
                return (
                  <li key={index} className="mb-3">
                    {/* <Nav.Link href={`/${item.page?.slug}/`}>
                      {item.menuItem}
                    </Nav.Link> */}
                    <Link
                      className="nav-link"
                      to={linkResolver(item?.page)}
                      activeClassName="active"
                    >
                      {item.menuItem}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <div className="buttons">
              <div className="border-bt">
                <Button
                  className="px-2 btn-white mb-3"
                  href={buttonHref}
                  style={{ maxWidth: "160px" }}
                  onClick={user !== null ? handleLogout : handleLogin}
                >
                  {buttonText}
                </Button>
              </div>

              <div className="border-bt">
                <LanguageSwitcher pageData={pageData} />
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  );
};

export default NavbarMobile;
